/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Homysign {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description List Templates.
   *
   * @tags Homysign
   * @name ListTemplates
   * @summary List Templates
   * @request GET:/api/homysign/templates
   * @secure
   */
  listTemplates = (params = {}) =>
    this.http.request({
      path: `/api/homysign/templates`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create Template.
   *
   * @tags Homysign
   * @name CreateTemplate
   * @summary Create Template
   * @request POST:/api/homysign/templates
   * @secure
   */
  createTemplate = (data, params = {}) =>
    this.http.request({
      path: `/api/homysign/templates`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get Template.
   *
   * @tags Homysign
   * @name GetTemplate
   * @summary Get Template
   * @request GET:/api/homysign/templates/{template_id}
   * @secure
   */
  getTemplate = (templateId, params = {}) =>
    this.http.request({
      path: `/api/homysign/templates/${templateId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update Template.
   *
   * @tags Homysign
   * @name UpdateTemplate
   * @summary Update Template
   * @request PUT:/api/homysign/templates/{template_id}
   * @secure
   */
  updateTemplate = (templateId, data, params = {}) =>
    this.http.request({
      path: `/api/homysign/templates/${templateId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete Template.
   *
   * @tags Homysign
   * @name DeleteTemplate
   * @summary Delete Template
   * @request DELETE:/api/homysign/templates/{template_id}
   * @secure
   */
  deleteTemplate = (templateId, params = {}) =>
    this.http.request({
      path: `/api/homysign/templates/${templateId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Return catalog of contract placeholders categorized into tenant, landlord, property, financial, dates, signature.
   *
   * @tags Homysign
   * @name GetPlaceholderCatalog
   * @summary Get Placeholder Catalog
   * @request GET:/api/homysign/placeholders
   * @secure
   */
  getPlaceholderCatalog = (params = {}) =>
    this.http.request({
      path: `/api/homysign/placeholders`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Alias for /api/homysign/placeholders under documents namespace.
   *
   * @tags Homysign
   * @name GetDocumentsPlaceholderCatalog
   * @summary Get Documents Placeholder Catalog
   * @request GET:/api/homysign/documents/placeholders
   * @secure
   */
  getDocumentsPlaceholderCatalog = (params = {}) =>
    this.http.request({
      path: `/api/homysign/documents/placeholders`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List Documents.
   *
   * @tags Homysign
   * @name ListDocuments
   * @summary List Documents
   * @request GET:/api/homysign/documents
   * @secure
   */
  listDocuments = (query, params = {}) =>
    this.http.request({
      path: `/api/homysign/documents`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create Document.
   *
   * @tags Homysign
   * @name CreateDocument
   * @summary Create Document
   * @request POST:/api/homysign/documents
   * @secure
   */
  createDocument = (data, params = {}) =>
    this.http.request({
      path: `/api/homysign/documents`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get Document.
   *
   * @tags Homysign
   * @name GetDocument
   * @summary Get Document
   * @request GET:/api/homysign/documents/{doc_id}
   * @secure
   */
  getDocument = (docId, params = {}) =>
    this.http.request({
      path: `/api/homysign/documents/${docId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update Document Content.
   *
   * @tags Homysign
   * @name UpdateDocumentContent
   * @summary Update Document Content
   * @request PUT:/api/homysign/documents/{doc_id}
   * @secure
   */
  updateDocumentContent = (docId, data, params = {}) =>
    this.http.request({
      path: `/api/homysign/documents/${docId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Send For Review.
   *
   * @tags Homysign
   * @name SendForReview
   * @summary Send For Review
   * @request POST:/api/homysign/documents/{doc_id}/send-for-review
   * @secure
   */
  sendForReview = (docId, data, params = {}) =>
    this.http.request({
      path: `/api/homysign/documents/${docId}/send-for-review`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Add Comment.
   *
   * @tags Homysign
   * @name AddComment
   * @summary Add Comment
   * @request POST:/api/homysign/documents/{doc_id}/comments
   * @secure
   */
  addComment = (docId, data, params = {}) =>
    this.http.request({
      path: `/api/homysign/documents/${docId}/comments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Resolve Comment.
   *
   * @tags Homysign
   * @name ResolveComment
   * @summary Resolve Comment
   * @request PUT:/api/homysign/documents/{doc_id}/comments/{comment_id}/resolve
   * @secure
   */
  resolveComment = (docId, commentId, params = {}) =>
    this.http.request({
      path: `/api/homysign/documents/${docId}/comments/${commentId}/resolve`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Dismiss Comment.
   *
   * @tags Homysign
   * @name DismissComment
   * @summary Dismiss Comment
   * @request PUT:/api/homysign/documents/{doc_id}/comments/{comment_id}/dismiss
   * @secure
   */
  dismissComment = (docId, commentId, params = {}) =>
    this.http.request({
      path: `/api/homysign/documents/${docId}/comments/${commentId}/dismiss`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Trigger Signing.
   *
   * @tags Homysign
   * @name TriggerSigning
   * @summary Trigger Signing
   * @request POST:/api/homysign/documents/{doc_id}/trigger-signing
   * @secure
   */
  triggerSigning = (docId, data, params = {}) =>
    this.http.request({
      path: `/api/homysign/documents/${docId}/trigger-signing`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List Signature Requests.
   *
   * @tags Homysign
   * @name ListSignatureRequests
   * @summary List Signature Requests
   * @request GET:/api/homysign/documents/{doc_id}/signature-requests
   * @secure
   */
  listSignatureRequests = (docId, params = {}) =>
    this.http.request({
      path: `/api/homysign/documents/${docId}/signature-requests`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get signing links for a document.
   *
   * @tags Homysign
   * @name GetSigningLinks
   * @summary Get Signing Links
   * @request GET:/api/homysign/documents/{doc_id}/signing-links
   * @secure
   */
  getSigningLinks = (docId, params = {}) =>
    this.http.request({
      path: `/api/homysign/documents/${docId}/signing-links`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List Versions.
   *
   * @tags Homysign
   * @name ListVersions
   * @summary List Versions
   * @request GET:/api/homysign/documents/{doc_id}/versions
   * @secure
   */
  listVersions = (docId, params = {}) =>
    this.http.request({
      path: `/api/homysign/documents/${docId}/versions`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Submit a signature — requires authentication (login).
   *
   * @tags Homysign
   * @name SubmitSignature
   * @summary Submit Signature
   * @request POST:/api/homysign/documents/{doc_id}/sign
   * @secure
   */
  submitSignature = (docId, query, data, params = {}) =>
    this.http.request({
      path: `/api/homysign/documents/${docId}/sign`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Void Document.
   *
   * @tags Homysign
   * @name VoidDocument
   * @summary Void Document
   * @request POST:/api/homysign/documents/{doc_id}/void
   * @secure
   */
  voidDocument = (docId, query, params = {}) =>
    this.http.request({
      path: `/api/homysign/documents/${docId}/void`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get Document Pdf.
   *
   * @tags Homysign
   * @name GetDocumentPdf
   * @summary Get Document Pdf
   * @request GET:/api/homysign/documents/{doc_id}/pdf
   * @secure
   */
  getDocumentPdf = (docId, params = {}) =>
    this.http.request({
      path: `/api/homysign/documents/${docId}/pdf`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Verify cryptographic integrity of a document.
   *
   * @tags Homysign
   * @name VerifyDocumentIntegrity
   * @summary Verify Document Integrity
   * @request GET:/api/homysign/documents/{doc_id}/verify
   * @secure
   */
  verifyDocumentIntegrity = (docId, params = {}) =>
    this.http.request({
      path: `/api/homysign/documents/${docId}/verify`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Record access audit trail event for authenticated user.
   *
   * @tags Homysign
   * @name RecordDocumentAccessLog
   * @summary Record Document Access Log
   * @request POST:/api/homysign/documents/{doc_id}/access-log
   * @secure
   */
  recordDocumentAccessLog = (docId, data, params = {}) =>
    this.http.request({
      path: `/api/homysign/documents/${docId}/access-log`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get Document Audit Trail.
   *
   * @tags Homysign
   * @name GetDocumentAuditTrail
   * @summary Get Document Audit Trail
   * @request GET:/api/homysign/documents/{doc_id}/audit
   * @secure
   */
  getDocumentAuditTrail = (docId, params = {}) =>
    this.http.request({
      path: `/api/homysign/documents/${docId}/audit`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
